import { B2CPolicies, MSALConfig, LoginRequest } from 'interfaces/auth/config';

const b2cPolicies: B2CPolicies = {
  names: {
    signUpSignIn: 'B2C_1_SignUpSignIn',
    passwordReset: 'B2C_1_PasswordReset'
  },
  authorities: {
    signUpSignIn: {
      authority:
        process.env.AZURE_B2C_SIGNIN_URL ||
        'https://iconiqcapitalb2c.b2clogin.com/iconiqcapitalb2c.onmicrosoft.com/B2C_1_SignUpSignIn'
    },
    passwordReset: {
      authority:
        'https://iconiqcapitalb2c.b2clogin.com/iconiqcapitalb2c.onmicrosoft.com/B2C_1_PasswordReset'
    }
  },
  authorityDomain: 'iconiqcapitalb2c.b2clogin.com'
};

export const msalConfig: MSALConfig = {
  auth: {
    clientId:
      process.env.AZURE_B2C_CLIENT_ID || '3bbec097-2846-4098-b0ff-3bcc732380d6',
    authority: b2cPolicies.authorities.signUpSignIn.authority,
    knownAuthorities: [b2cPolicies.authorityDomain],
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false
  }
};

export const loginRequest: LoginRequest = {
  scopes: [
    'openid',
    'profile',
    'email',
    'offline_access',
    'https://iconiqcapitalb2c.onmicrosoft.com/3bbec097-2846-4098-b0ff-3bcc732380d6/DataAccess'
  ]
};

export const updateAuthority = (
  userFlow: keyof B2CPolicies['authorities']
): void => {
  if (b2cPolicies.authorities[userFlow]) {
    msalConfig.auth.authority = b2cPolicies.authorities[userFlow].authority;
  } else {
    console.error(`User flow "${userFlow}" not found in b2cPolicies.`);
  }
};

export default b2cPolicies;
